<template>
  <div id="app">
    <template v-if="isAuthPage">
      <router-view />
    </template>
    <template v-else-if="started">
    <!-- <ul class="lightrope">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul> -->
      <SideMenu />
      <GlobalHeaderWidgets />
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { checkToken } from "@/api";
//
import "@/assets/main.css";
//
import SideMenu from "@/components/ui/SideMenu";
import GlobalHeaderWidgets from "@/components/ui/GlobalHeaderWidgets";
//
export default {
  name: "App",

  data: () => ({
    started: false,
  }),

  components: { SideMenu, GlobalHeaderWidgets },

  methods: {
    ...mapMutations("auth", ["setSession"]),

    init() {
      const auth = localStorage.getItem("Auth");
      if (!auth) {
        this.$router.push("/login");
        return;
      }
      const session = JSON.parse(auth);
      //
      this.setSession(session);
      //
      checkToken(session.token)
        .then((result) => {
          if (result.data && result.data.mustChangePassword) {
            this.$router.push("/change-password");
            return;
          }
          this.started = true;
          //
          if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
            return;
          }
          Notification.requestPermission();
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            localStorage.removeItem("Auth");
            this.$router.push("/login");
          } else {
            alert("Failed login");
          }
        });
    },
    // Сокет может (пере)подключиться раньше, чем this.session успеет
    // восстановиться в сторе (например, сразу после полной перезагрузки
    // страницы) — раньше это падало с TypeError на this.session.token,
    // молча проглатывалось try/catch, и сокет так и оставался
    // неаутентифицированным до следующего переподключения. Теперь просто
    // ничего не делаем, если сессии ещё нет — а watch ниже дозовёт emitAuth,
    // как только сессия появится, не дожидаясь нового connect.
    emitAuth() {
      if (!this.session) return;
      this.$socket.emit("auth", { token: this.session.token });
    },
  },

  computed: {
    ...mapState("auth", ["session"]),
    isAuthPage() {
      return ["/login", "/change-password"].includes(this.$route.path);
    },
  },

  watch: {
    session(session) {
      if (session) this.emitAuth();
    },
    isAuthPage(isAuthPage, wasAuthPage) {
      if (wasAuthPage && !isAuthPage && !this.started) {
        this.init();
      }
    },
  },

  mounted() {
    this.init();
  },

  sockets: {
    connect() {
      this.emitAuth();
    },

    notification(data) {
      if (Notification.permission === "granted") {
        new Notification(data.title, {
          body: data.body,
          tag: "renotify",
          renotify: true,
        });
      }
    },
  },
};
</script>
<style scoped>
.lightrope {
  position: fixed;
  /* height: 60px; */
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  /* position: absolute; */
  z-index: 10000;
  margin: -15px 0 0 0;
  padding: 0;
  pointer-events: none;
  width: 100%;
}
.lightrope li {
  position: relative;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  list-style: none;
  margin: 0;
  padding: 0;
  display: block;
  width: 6px;
  height: 12px;
  border-radius: 50%;
  margin: calc(40px / 2);
  display: inline-block;
  background: rgba(0, 247, 165, 1);
  box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(0, 247, 165, 1);
  animation-name: flash-1;
  animation-duration: 2s;
}
.lightrope li:nth-child(2n + 1) {
  background: rgba(0, 255, 255, 1);
  box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(0, 255, 255, 0.5);
  animation-name: flash-2;
  animation-duration: 0.4s;
}
.lightrope li:nth-child(4n + 2) {
  background: rgba(247, 0, 148, 1);
  box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(247, 0, 148, 1);
  animation-name: flash-3;
  animation-duration: 1.1s;
}
.lightrope li:nth-child(odd) {
  animation-duration: 1.8s;
}
.lightrope li:nth-child(3n + 1) {
  animation-duration: 1.4s;
}
.lightrope li:before {
  content: "";
  position: absolute;
  background: #222;
  width: calc(6px - 2);
  height: calc(12px / 3);
  border-radius: 3px;
  top: calc(0 - (12px / 6));
  left: 1px;
}
.lightrope li:after {
  content: "";
  top: calc(0 - 12px / 2);
  left: calc(6px - 3);
  position: absolute;
  width: calc(40px + 12);
  height: calc(12px / 3 * 2);
  border-bottom: solid #222 2px;
  border-radius: 50%;
}
.lightrope li:last-child:after {
  content: none;
}
.lightrope li:first-child {
  margin-left: -40px;
}

@keyframes flash-1 {
  0%,
  100% {
    background: rgba(0, 247, 165, 1);
    box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(0, 247, 165, 1);
  }
  50% {
    background: rgba(0, 247, 165, 0.4);
    box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(0, 247, 165, 0.2);
  }
}
@keyframes flash-2 {
  0%,
  100% {
    background: rgba(0, 255, 255, 1);
    box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(0, 255, 255, 1);
  }
  50% {
    background: rgba(0, 255, 255, 0.4);
    box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(0, 255, 255, 0.2);
  }
}
@keyframes flash-3 {
  0%,
  100% {
    background: rgba(247, 0, 148, 1);
    box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(247, 0, 148, 1);
  }
  50% {
    background: rgba(247, 0, 148, 0.4);
    box-shadow: 0px calc(12px / 6) calc(6px * 2) 2px rgba(247, 0, 148, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue